import { MtAccountPackage } from "server/models"
import { OrderType } from "client/utils"


export interface AccountPackageList { [accountId: number]: MtAccountPackage[]}
export type AccountPackageValidation = { [key in keyof MtAccountPackage]?: string}

export interface PackageUsage {
    maxCalculations: number // number of all calculations for the current term including remains
    usedCalculations: number
}

export interface AccountPackageState {
    accountPackageList: AccountPackageList
    accountPackageEdit: MtAccountPackage

    packageAllowed: number[]

    sortColumn: keyof MtAccountPackage
    sortOrder: OrderType

    reloadList: boolean
    reloadEdit: boolean
}

export const ACCOUNT_PACKAGE_LIST = "ACCOUNT_PACKAGE_LIST"
export const ACCOUNT_PACKAGE_EDIT = "ACCOUNT_PACKAGE_EDIT"

export const ACCOUNT_PACKAGE_ALLOWED = "ACCOUNT_PACKAGE_ALLOWED"

export const ACCOUNT_PACKAGE_SORT = "ACCOUNT_PACKAGE_SORT"

export const ACCOUNT_PACKAGE_RELOAD_LIST = "ACCOUNT_PACKAGE_RELOAD_LIST"
export const ACCOUNT_PACKAGE_RELOAD_EDIT = "ACCOUNT_PACKAGE_RELOAD_EDIT"
